export default __webpack_public_path__ + "static/media/7.ddb69958.mp3";